export default __webpack_public_path__ + "static/media/dismiss.be2b8c7d.svg";